// Dummy data for demo mode - Complete user profiles, conversations, and messages

export const DEMO_USERS = [
  {
    _id: 'demo_user_1',
    email: 'priya.sharma@demo.com',
    phoneNumber: '+919876543210',
    firstName: 'Priya',
    lastName: 'Sharma',
    gender: 'female',
    dateOfBirth: '1998-03-15',
    role: 'user',
    isActive: true,
    verifications: {
      email: true,
      phone: true,
      photo: true,
      government: false
    },
    subscription: {
      planId: 'premium_plan',
      isActive: true,
      startDate: '2024-01-01',
      endDate: '2025-01-01',
      contactViews: 50,
      photoRequests: 100
    },
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400',
      photos: [
        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400',
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400'
      ],
      age: 26,
      height: 165,
      religion: 'Hindu',
      caste: 'Brahmin',
      motherTongue: 'Hindi',
      maritalStatus: 'Never Married',
      education: 'B.Tech in Computer Science',
      occupation: 'Software Engineer',
      employedIn: 'Private Sector',
      annualIncome: '₹12-15 Lakhs',
      city: 'Mumbai',
      state: 'Maharashtra',
      country: 'India',
      bio: 'Hi! I\'m Priya, a software engineer working in Mumbai. I love traveling, reading books, and trying new cuisines. Looking for someone who shares similar interests and values family.',
      familyDetails: {
        fatherOccupation: 'Business Owner',
        motherOccupation: 'Homemaker',
        siblings: '1 Sister',
        familyType: 'Nuclear Family',
        familyValues: 'Traditional'
      },
      lifestyle: {
        diet: 'Vegetarian',
        smoking: 'No',
        drinking: 'No'
      },
      hobbies: ['Reading', 'Traveling', 'Cooking', 'Photography'],
      partnerPreferences: {
        minAge: 26,
        maxAge: 32,
        minHeight: 170,
        maxHeight: 185,
        religion: 'Hindu',
        education: 'Bachelor\'s Degree or higher',
        occupation: 'Professional'
      }
    }
  },
  {
    _id: 'demo_user_2',
    email: 'rahul.verma@demo.com',
    phoneNumber: '+919876543211',
    firstName: 'Rahul',
    lastName: 'Verma',
    gender: 'male',
    dateOfBirth: '1995-07-22',
    role: 'user',
    isActive: true,
    verifications: {
      email: true,
      phone: true,
      photo: true,
      government: true
    },
    subscription: {
      planId: 'gold_plan',
      isActive: true,
      startDate: '2024-01-15',
      endDate: '2024-07-15',
      contactViews: 30,
      photoRequests: 50
    },
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      photos: [
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400'
      ],
      age: 29,
      height: 178,
      religion: 'Hindu',
      caste: 'Punjabi',
      motherTongue: 'Punjabi',
      maritalStatus: 'Never Married',
      education: 'MBA in Finance',
      occupation: 'Investment Banker',
      employedIn: 'Private Sector',
      annualIncome: '₹20-25 Lakhs',
      city: 'Delhi',
      state: 'Delhi',
      country: 'India',
      bio: 'Investment banker by profession, foodie by heart. Love exploring new restaurants and traveling to new places. Looking for a life partner who is independent and has a good sense of humor.',
      familyDetails: {
        fatherOccupation: 'Retired Government Officer',
        motherOccupation: 'Teacher',
        siblings: '1 Brother',
        familyType: 'Joint Family',
        familyValues: 'Moderate'
      },
      lifestyle: {
        diet: 'Non-Vegetarian',
        smoking: 'No',
        drinking: 'Occasionally'
      },
      hobbies: ['Traveling', 'Gym', 'Cricket', 'Movies'],
      partnerPreferences: {
        minAge: 24,
        maxAge: 28,
        minHeight: 155,
        maxHeight: 170,
        religion: 'Any',
        education: 'Bachelor\'s Degree or higher',
        occupation: 'Professional'
      }
    }
  },
  {
    _id: 'demo_user_3',
    email: 'ananya.singh@demo.com',
    phoneNumber: '+919876543212',
    firstName: 'Ananya',
    lastName: 'Singh',
    gender: 'female',
    dateOfBirth: '1999-11-08',
    role: 'user',
    isActive: true,
    verifications: {
      email: true,
      phone: false,
      photo: true,
      government: false
    },
    subscription: {
      planId: null,
      isActive: false,
      contactViews: 5,
      photoRequests: 10
    },
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400',
      photos: [
        'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400',
        'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400'
      ],
      age: 25,
      height: 162,
      religion: 'Hindu',
      caste: 'Rajput',
      motherTongue: 'Hindi',
      maritalStatus: 'Never Married',
      education: 'BBA in Marketing',
      occupation: 'Marketing Manager',
      employedIn: 'Private Sector',
      annualIncome: '₹8-10 Lakhs',
      city: 'Bangalore',
      state: 'Karnataka',
      country: 'India',
      bio: 'Creative marketing professional who loves art, music, and dance. Passionate about creating meaningful campaigns. Looking for someone genuine and caring.',
      familyDetails: {
        fatherOccupation: 'Businessman',
        motherOccupation: 'Homemaker',
        siblings: 'None',
        familyType: 'Nuclear Family',
        familyValues: 'Traditional'
      },
      lifestyle: {
        diet: 'Vegetarian',
        smoking: 'No',
        drinking: 'No'
      },
      hobbies: ['Dancing', 'Painting', 'Music', 'Yoga'],
      partnerPreferences: {
        minAge: 26,
        maxAge: 33,
        minHeight: 170,
        maxHeight: 185,
        religion: 'Hindu',
        education: 'Bachelor\'s Degree or higher',
        occupation: 'Professional'
      }
    }
  }
];

// Additional match profiles for the logged-in user to see
export const DEMO_MATCH_PROFILES = [
  {
    _id: 'match_1',
    firstName: 'Kavya',
    lastName: 'Mehta',
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400',
      photos: [
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400',
        'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400'
      ],
      age: 27,
      height: 160,
      religion: 'Hindu',
      occupation: 'Doctor',
      education: 'MBBS',
      city: 'Pune',
      state: 'Maharashtra',
      country: 'India',
      bio: 'Pediatrician with a passion for child healthcare. Love spending weekends with family and friends.'
    },
    isPro: true,
    verifications: { email: true, phone: true }
  },
  {
    _id: 'match_2',
    firstName: 'Meera',
    lastName: 'Reddy',
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400',
      photos: [
        'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400'
      ],
      age: 24,
      height: 168,
      religion: 'Hindu',
      occupation: 'Fashion Designer',
      education: 'B.Des',
      city: 'Hyderabad',
      state: 'Telangana',
      country: 'India',
      bio: 'Creative fashion designer who loves to experiment with traditional and modern designs.'
    },
    isPro: true,
    verifications: { email: true, phone: true }
  },
  {
    _id: 'match_3',
    firstName: 'Arjun',
    lastName: 'Kapoor',
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=400',
      photos: [
        'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=400',
        'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=400'
      ],
      age: 30,
      height: 182,
      religion: 'Hindu',
      occupation: 'Civil Engineer',
      education: 'B.Tech',
      city: 'Chennai',
      state: 'Tamil Nadu',
      country: 'India',
      bio: 'Civil engineer working on infrastructure projects. Love cricket and traveling.'
    },
    isPro: false,
    verifications: { email: true, phone: false }
  },
  {
    _id: 'match_4',
    firstName: 'Sneha',
    lastName: 'Patel',
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400',
      photos: [
        'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400'
      ],
      age: 26,
      height: 163,
      religion: 'Hindu',
      occupation: 'CA',
      education: 'Chartered Accountant',
      city: 'Ahmedabad',
      state: 'Gujarat',
      country: 'India',
      bio: 'Chartered Accountant with a love for numbers and finance. Enjoy reading and cooking.'
    },
    isPro: false,
    verifications: { email: true, phone: true }
  },
  {
    _id: 'match_5',
    firstName: 'Vikram',
    lastName: 'Joshi',
    profile: {
      profilePhoto: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400',
      photos: [
        'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400',
        'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400'
      ],
      age: 31,
      height: 175,
      religion: 'Hindu',
      occupation: 'Entrepreneur',
      education: 'MBA',
      city: 'Jaipur',
      state: 'Rajasthan',
      country: 'India',
      bio: 'Running my own startup in the e-commerce space. Passionate about innovation and technology.'
    },
    isPro: true,
    verifications: { email: true, phone: true }
  }
];

// Demo conversations for the messages tab
export const DEMO_CONVERSATIONS = [
  {
    _id: 'conv_1',
    participants: [
      { _id: 'demo_user_1' },
      {
        _id: 'match_1',
        firstName: 'Kavya',
        lastName: 'Mehta',
        profile: {
          profilePhoto: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400',
          age: 27
        }
      }
    ],
    lastMessage: {
      _id: 'msg_1',
      content: 'That sounds like a great hobby! 😊',
      senderId: 'match_1',
      createdAt: new Date(Date.now() - 2 * 60 * 1000).toISOString(),
      isRead: false
    },
    unreadCount: 1,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 1000).toISOString()
  },
  {
    _id: 'conv_2',
    participants: [
      { _id: 'demo_user_1' },
      {
        _id: 'match_2',
        firstName: 'Meera',
        lastName: 'Reddy',
        profile: {
          profilePhoto: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400',
          age: 24
        }
      }
    ],
    lastMessage: {
      _id: 'msg_2',
      content: 'Let\'s connect this weekend?',
      senderId: 'demo_user_1',
      createdAt: new Date(Date.now() - 60 * 60 * 1000).toISOString(),
      isRead: true
    },
    unreadCount: 0,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 60 * 60 * 1000).toISOString()
  },
  {
    _id: 'conv_3',
    participants: [
      { _id: 'demo_user_1' },
      {
        _id: 'match_3',
        firstName: 'Arjun',
        lastName: 'Kapoor',
        profile: {
          profilePhoto: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=400',
          age: 30
        }
      }
    ],
    lastMessage: {
      _id: 'msg_3',
      content: 'Sent a photo',
      senderId: 'match_3',
      createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
      isRead: true
    },
    unreadCount: 0,
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()
  }
];

// Demo messages for conversations
export const DEMO_MESSAGES: { [key: string]: any[] } = {
  conv_1: [
    {
      _id: 'msg_1_1',
      conversationId: 'conv_1',
      senderId: 'demo_user_1',
      content: 'Hi Kavya! I saw your profile and would love to connect.',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_1_2',
      conversationId: 'conv_1',
      senderId: 'match_1',
      content: 'Hi Priya! Thank you for reaching out. I checked your profile too!',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 10 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_1_3',
      conversationId: 'conv_1',
      senderId: 'demo_user_1',
      content: 'I noticed you work as a doctor. That\'s really admirable! What made you choose pediatrics?',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 30 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_1_4',
      conversationId: 'conv_1',
      senderId: 'match_1',
      content: 'I\'ve always loved working with children. They bring so much joy! What do you do in your free time?',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 45 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_1_5',
      conversationId: 'conv_1',
      senderId: 'demo_user_1',
      content: 'I love traveling and photography! I try to visit new places whenever I get time. Have you traveled anywhere recently?',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 60 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_1',
      conversationId: 'conv_1',
      senderId: 'match_1',
      content: 'That sounds like a great hobby! 😊',
      messageType: 'text',
      isRead: false,
      createdAt: new Date(Date.now() - 2 * 60 * 1000).toISOString()
    }
  ],
  conv_2: [
    {
      _id: 'msg_2_1',
      conversationId: 'conv_2',
      senderId: 'match_2',
      content: 'Hi Priya! Your profile caught my attention. I love your sense of style!',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_2_2',
      conversationId: 'conv_2',
      senderId: 'demo_user_1',
      content: 'Thank you so much! I saw you\'re a fashion designer. That\'s so cool!',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000 + 20 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_2',
      conversationId: 'conv_2',
      senderId: 'demo_user_1',
      content: 'Let\'s connect this weekend?',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 60 * 60 * 1000).toISOString()
    }
  ],
  conv_3: [
    {
      _id: 'msg_3_1',
      conversationId: 'conv_3',
      senderId: 'demo_user_1',
      content: 'Hi Arjun! I really liked your profile.',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_3_2',
      conversationId: 'conv_3',
      senderId: 'match_3',
      content: 'Hi Priya! Thank you for connecting. How are you?',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000 + 30 * 60 * 1000).toISOString()
    },
    {
      _id: 'msg_3',
      conversationId: 'conv_3',
      senderId: 'match_3',
      content: 'Sent a photo',
      messageType: 'text',
      isRead: true,
      createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()
    }
  ]
};

// Online users (for presence indicators)
export const DEMO_ONLINE_USERS = ['match_1', 'match_2'];

// User presence data
export const DEMO_USER_PRESENCE: { [key: string]: any } = {
  match_1: {
    userId: 'match_1',
    isOnline: true,
    lastSeen: new Date()
  },
  match_2: {
    userId: 'match_2',
    isOnline: true,
    lastSeen: new Date()
  },
  match_3: {
    userId: 'match_3',
    isOnline: false,
    lastSeen: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
  }
};

// Interest/Shortlist data
export const DEMO_INTERESTS = {
  sent: ['match_2', 'match_4'],
  received: ['match_1', 'match_3'],
  accepted: ['match_1', 'match_2']
};

export const DEMO_SHORTLISTED = ['match_1', 'match_5'];

// Helper to get demo user by ID
export const getDemoUser = (userId: string) => {
  return DEMO_USERS.find(user => user._id === userId);
};

// Helper to check if demo mode is active
export const isDemoMode = () => {
  return localStorage.getItem('demoMode') === 'true';
};

// Helper to set demo mode
export const setDemoMode = (enabled: boolean) => {
  localStorage.setItem('demoMode', enabled ? 'true' : 'false');
};

// Helper to get current demo user
export const getCurrentDemoUser = () => {
  const demoUserId = localStorage.getItem('demoUserId') || 'demo_user_1';
  return getDemoUser(demoUserId);
};

// Helper to switch demo user
export const switchDemoUser = (userId: string) => {
  localStorage.setItem('demoUserId', userId);
};
